// The board's task list, joined from two requests.
//
// The board loads the 100 most recently messaged tasks — bounded because
// the unindexed sort on the whole collection timed out — and sorts its
// columns from those. On a busy day every one of the 100 is new, and a task
// somebody is working on, last messaged last week, drops off the board: the
// In Progress column reads "No tasks in this column" while the server has
// plenty. In-progress tasks are few, so they are asked for on their own and
// joined here. The recent list comes first and wins on a duplicate.
export interface BoardTaskLike { id: string | number; status?: string }

export function mergeBoardLists<T extends BoardTaskLike>(recent: T[], inProgress: T[]): T[] {
  const seen = new Set(recent.map((t) => String(t.id)));
  const extra = inProgress.filter((t) => !seen.has(String(t.id)));
  return [...recent, ...extra];
}
